"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ColorIndicator = require("./ColorIndicator.styled");
var _jsxRuntime = require("react/jsx-runtime");
var ColorIndicatorWrapper = (0, _styledComponents.default)(_ColorIndicator.ColorIndicatorStyled).withConfig({
  displayName: "ColorIndicator__ColorIndicatorWrapper",
  componentId: "sc-sxq00h-0"
})(["height:20px;width:20px;"]);
var ColorIndicator = function ColorIndicator(_ref) {
  var className = _ref.className,
    color = _ref.color;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ColorIndicatorWrapper, {
    className: className,
    color: color
  });
};
ColorIndicator.defaultProps = {
  color: '#FEB6B3'
};
var _default = exports.default = ColorIndicator;